import getTenantConfig from './getTenantConfig';

/**
 * Applies tenant-driven side-effects to <head>:
 * - document.title = `${title} Dashboard`
 * - <link rel="icon"> href is set to the tenant favicon
 *
 * The icon link is expected to already exist in index.html.
 * Not a React hook — tenant does not change at runtime, so this is meant to run once on bootstrap.
 */
const applyTenantDocumentEffects = (): void => {
  const { title, faviconUrl } = getTenantConfig();

  document.title = `${title} Dashboard`;

  const link = document.querySelector<HTMLLinkElement>('link[rel=icon]');
  if (!link) {
    throw new Error('applyTenantDocumentEffects: <link rel=icon> not found in <head>');
  }
  link.href = faviconUrl;
};

export default applyTenantDocumentEffects;
